// extracted by mini-css-extract-plugin
export default {"wrapper":"recaptcha__wrapper__PzY1U","skeleton-loading":"recaptcha__skeleton-loading__cU4hs","loader":"recaptcha__loader__gXFp5","notesText":"recaptcha__notesText__T1WZp"};